import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@common/components';
import { cn } from '@core/utils';
import { useState } from 'react';
import { Image } from '@/components/client';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { useMediaQuery } from '@/hooks/useMediaQuery';
interface DesktopMainImagesProps {
  title: string;
  heroImageUrlList: string[];
  adultYN: boolean;
}
export const DesktopMainImages = t0 => {
  const $ = _c(29);
  const {
    title,
    heroImageUrlList,
    adultYN
  } = t0;
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP, false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new Set([0]);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [loadedImages, setLoadedImages] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = index => {
      setSelectedImageIndex(index);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleImageSelect = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = index_0 => {
      setLoadedImages(prev => new Set(prev).add(index_0));
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleImageLoad = t3;
  let t4;
  if ($[3] !== loadedImages || $[4] !== selectedImageIndex) {
    t4 = loadedImages.has(selectedImageIndex);
    $[3] = loadedImages;
    $[4] = selectedImageIndex;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const isCurrentImageLoaded = t4;
  let t5;
  if ($[6] !== heroImageUrlList || $[7] !== isCurrentImageLoaded || $[8] !== isDesktopViewport || $[9] !== selectedImageIndex || $[10] !== title) {
    t5 = isDesktopViewport || selectedImageIndex === 0 ? <>{!isCurrentImageLoaded && <Skeleton className="absolute inset-0 size-full rounded-[48px]" />}<div className="relative size-full rounded-[48px]"><Image key={selectedImageIndex} fill={true} preload={true} alt={title || "\uC6F0\uB85C \uACE0\uD5A5\uC0AC\uB791\uAE30\uBD80 \uB2F5\uB840\uD488"} src={heroImageUrlList[selectedImageIndex]} sizes="(min-width: 1280px) 50vw" className={cn("rounded-[48px] object-cover object-center transition-opacity duration-200", !isCurrentImageLoaded && "opacity-0")} onLoad={() => handleImageLoad(selectedImageIndex)} /></div></> : <Skeleton className="size-full rounded-[48px]" />;
    $[6] = heroImageUrlList;
    $[7] = isCurrentImageLoaded;
    $[8] = isDesktopViewport;
    $[9] = selectedImageIndex;
    $[10] = title;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== adultYN) {
    t6 = adultYN && <div className="absolute left-20 top-20 rounded-xsmall bg-B-500 px-12 py-4 font-600 text-Gray-white typo-body4">19세이상 구매가능</div>;
    $[12] = adultYN;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <div className="relative mb-20 aspect-square">{t5}{t6}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== heroImageUrlList || $[18] !== selectedImageIndex || $[19] !== title) {
    let t9;
    if ($[21] !== selectedImageIndex || $[22] !== title) {
      t9 = (imageUrl, index_1) => <div key={index_1} className={cn("relative aspect-square w-full cursor-pointer overflow-hidden rounded-large", {
        "border-1 border-Gray-black": selectedImageIndex === index_1
      })} onClick={() => handleImageSelect(index_1)}><Image fill={true} loading="lazy" src={imageUrl} alt={title || "\uC6F0\uB85C \uACE0\uD5A5\uC0AC\uB791\uAE30\uBD80 \uB2F5\uB840\uD488"} sizes="(min-width: 1280px) 8vw" className="object-cover" /></div>;
      $[21] = selectedImageIndex;
      $[22] = title;
      $[23] = t9;
    } else {
      t9 = $[23];
    }
    t8 = heroImageUrlList.map(t9);
    $[17] = heroImageUrlList;
    $[18] = selectedImageIndex;
    $[19] = title;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[24] !== t8) {
    t9 = <div className="grid grid-cols-6 gap-10">{t8}</div>;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t7 || $[27] !== t9) {
    t10 = <div className="mobile:hidden tablet:hidden">{t7}{t9}</div>;
    $[26] = t7;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};